// extracted by mini-css-extract-plugin
module.exports = {"loader":"fAlj7GE5F0pqQLnfwXU6x","load6":"AaOqBIl54gtiLoupBhw7o","round":"mPNVuU8Smm7lJRmI5cdSU"};